import { map2LegacyTheme as map2ColorLegacyTheme } from './mappers/color';
import { map2LegacyTheme as map2ConstantsLegacyTheme } from './mappers/constants';
import { map2LegacyTheme as map2FontFamilyLegacyTheme } from './mappers/fontFamily';
import { map2LegacyTheme as map2FontSizeLegacyTheme } from './mappers/fontSize';
import { map2LegacyTheme as map2FontWeightLegacyTheme } from './mappers/fontWeight';
import { map2LegacyTheme as map2RadiusLegacyTheme } from './mappers/radius';
import { map2LegacyTheme as map2SpaceLegacyTheme } from './mappers/space';
import { map2LegacyTheme as map2ZIndexLegacyTheme } from './mappers/zIndex';
export const convertToLegacyTheme = _ref => {
  let {
    tokens,
    legacyTheme
  } = _ref;
  if (!tokens[':root'] || Object.keys(tokens[':root']).length === 0) {
    return {
      legacyTheme
    };
  }
  const legacyColor = map2ColorLegacyTheme(tokens, legacyTheme['color']);
  const legacySpace = map2SpaceLegacyTheme(tokens, legacyTheme['space']);
  const legacyRadius = map2RadiusLegacyTheme(tokens, legacyTheme['radius']);
  const legacyZIndex = map2ZIndexLegacyTheme(tokens, legacyTheme['zIndex']);
  const legacyFontWeight = map2FontWeightLegacyTheme(tokens, legacyTheme['font']['primary']['fontWeight']);
  const legacyFontFamily = map2FontFamilyLegacyTheme(tokens, legacyTheme['font']);
  const legacyFontSize = map2FontSizeLegacyTheme(tokens, legacyTheme['font']['primary']['size']);
  const legacyConstants = map2ConstantsLegacyTheme(tokens, legacyTheme['constants']);
  const convertedLegacyTheme = {
    ...legacyTheme,
    color: legacyColor,
    // breakpoints are mapped separately
    breakpoint: legacyTheme.breakpoint,
    radius: legacyRadius,
    space: legacySpace,
    zIndex: legacyZIndex,
    constants: legacyConstants,
    font: {
      monospace: {
        ...legacyTheme.font.monospace,
        family: legacyFontFamily.monospace.family
      },
      primary: {
        family: legacyFontFamily.primary.family,
        size: legacyFontSize,
        fontWeight: legacyFontWeight
      }
    }
  };
  return {
    legacyTheme: convertedLegacyTheme
  };
};